var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubuser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.186,
    height: 18.915,
    viewBox: "0 0 14.186 18.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_3_",
    "data-name": "user(3)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5004",
    "data-name": "Path 5004",
    d: "M10.729,9.458A4.729,4.729,0,1,0,6,4.729a4.729,4.729,0,0,0,4.729,4.729Zm0-7.881A3.153,3.153,0,1,1,7.576,4.729a3.153,3.153,0,0,1,3.153-3.153Z",
    transform: "translate(-3.636 0)",
    fill: "#00baf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5005",
    "data-name": "Path 5005",
    d: "M10.093,14A7.1,7.1,0,0,0,3,21.093a.788.788,0,0,0,1.576,0,5.517,5.517,0,1,1,11.034,0,.788.788,0,0,0,1.576,0A7.1,7.1,0,0,0,10.093,14Z",
    transform: "translate(-3 -2.966)",
    fill: "#00baf2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubuser);
export default __webpack_public_path__ + "static/media/subuser.4b444111cf1f15ffe945eed87db8a995.svg";
export { ForwardRef as ReactComponent };